function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRestorei = function SvgRestorei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m8.051 21.235.442 1.251a.7.7 0 0 1-.426.893.7.7 0 0 1-.893-.426L6.15 20.059a.7.7 0 0 1 .426-.893l2.895-1.024a.7.7 0 0 1 .893.426.7.7 0 0 1-.426.893l-1.354.479c3.403 1.444 7.492.581 9.996-2.394 3.073-3.652 2.603-9.111-1.049-12.184a8.6 8.6 0 0 0-4.323-1.941.7.7 0 1 1 .2-1.386 10 10 0 0 1 5.025 2.255c4.243 3.571 4.789 9.914 1.218 14.157-2.906 3.453-7.648 4.458-11.6 2.787zM4.553 16.44a.7.7 0 0 1-1.2.721 10 10 0 0 1-1.143-2.773.7.7 0 0 1 1.359-.334 8.6 8.6 0 0 0 .983 2.386zM3.501 10.2a.7.7 0 0 1-1.37-.286 10 10 0 0 1 1.047-2.811.7.7 0 1 1 1.224.68 8.6 8.6 0 0 0-.901 2.417m3.474-5.286a.7.7 0 1 1-.808-1.143 10 10 0 0 1 2.682-1.344.7.7 0 0 1 .433 1.331 8.6 8.6 0 0 0-2.306 1.155z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRestorei);
export default ForwardRef;